import svgToTinyDataUri from '../svg-to-mini-data-uri';

const footerPhoneIconSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M3 2h3l1 3-2 1.5c.5 1 1.5 2 2.5 2.5L9 7l3 1v3c-5 0-9-4-9-9z"
    stroke="#2B2A35"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const footerPhoneIcon = svgToTinyDataUri(footerPhoneIconSvg);
